import React, { FC, useCallback } from 'react';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useFormState } from 'react-hook-form';
import classNames from 'classnames';

import styles from './researchFormWizardStyles.scss';

const ResearchFormWizardStep: FC<{
  isActive: boolean;
  isCompleted: boolean;
  isLoading: boolean;
  isPreviousStepCompleted: boolean;
  label: string;
  onClick: () => void;
  stepCount: number;
}> = ({ isActive, isCompleted, isLoading, isPreviousStepCompleted, label, onClick, stepCount }) => {
  const { isDirty, isSubmitting } = useFormState();

  const generateStepIcon = useCallback(
    () =>
      isActive && isSubmitting ? (
        <FontAwesomeIcon icon={faSpinner} spin />
      ) : isCompleted ? (
        <FontAwesomeIcon icon={faCheck} />
      ) : (
        stepCount
      ),
    [isActive, isCompleted, isSubmitting, stepCount]
  );

  const disabled = !((isCompleted || isPreviousStepCompleted) && !isDirty && !isLoading);

  return (
    <button
      className={classNames(styles.stepButton, {
        [styles.stepButtonActive]: isActive && !isLoading,
        [styles.stepButtonCompleted]: isCompleted
      })}
      disabled={disabled}
      onClick={onClick}
    >
      <div className={styles.stepButtonIcon}>{generateStepIcon()}</div>
      <span className={styles.stepButtonLabel}>{label}</span>
    </button>
  );
};

export default ResearchFormWizardStep;
